import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=f34fb672&scoped=true&"
import script from "./NavigationFooter.vue?vue&type=script&lang=ts&"
export * from "./NavigationFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&id=f34fb672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34fb672",
  null
  
)

export default component.exports